
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/web-design",
      function () {
        return require("private-next-pages/services/web-design.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/web-design"])
      });
    }
  